import _snakeCase from 'lodash.snakecase';

import type { FilingTypeApiSetData, FilingTypeSetData } from '@api/filingTypes';
import { formatRegApiDate } from '@models/Registrations/registrationsDetailSetModel/helpers';

/**
 * Converts data for API submission
 */
export const filingTypesSetModel = (
  {
    id,
    entityJurisdictionId,
    dayDue,
    endingMonths,
    startDate,
    submissionPeriod,
    userExperience,
  } = {} as FilingTypeSetData
): FilingTypeApiSetData => ({
  ...(id ? { id } : {}),
  period: submissionPeriod,
  entity_jurisdiction: entityJurisdictionId,
  date_filing_start: formatRegApiDate(startDate as Date),
  day_month: dayDue,
  ending_months: endingMonths,
  user_experience: _snakeCase(userExperience),
});
